import React, { useState } from 'react';
import './Login.css';
import { api } from '../../services/api';

export default function Login({ onLogin }) {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      const response = await api.login(credentials.email, credentials.password);
      
      if (response.success) {
        const userInfo = api.getUserInfo();
        onLogin({
          username: userInfo.name,
          userCode: userInfo.userCode,
          type: userInfo.type,
          contracts: userInfo.contracts,
          dashboard: userInfo.dashboard,
        });
      } else {
        setError(response.error || 'שם משתמש או סיסמא שגויים');
      }
    } catch (err) {
      // הצג הודעת שגיאה ברורה יותר
      let errorMessage = err.message || 'שגיאה בהתחברות. נסה שוב.';
      
      // אם זו שגיאת "Failed to fetch" - הוסף הסבר
      if (errorMessage.includes('Failed to fetch') || errorMessage.includes('לא ניתן להתחבר לשרת')) {
        errorMessage = errorMessage;
      }
      
      // אם זו שגיאת לוגאין מהשרת - הצג אותה כפי שהיא
      if (errorMessage.includes('שם משתמש או סיסמה') || errorMessage.includes('אינם תקינים')) {
        // השאר את ההודעה כפי שהיא - היא כבר ברורה
      }
      
      // שמור את השגיאה המפורטת בקונסול למנהל מערכת
      console.error('Login Error (מפורט למנהל מערכת):', err);
      if (err.stack) {
        console.error('Error Stack:', err.stack);
      }
      
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="login-container"
      style={{
        background: "url('/img/ceramic-bg.jpg') center center/cover no-repeat"
      }}
    >
      <div className="login-box">
        <div style={{ marginBottom: 24, textAlign: 'center' }}>
          {/* לוגו/אייקון */}
          {/* <span style={{
            display: 'inline-block',
            width: 40, height: 40,
            background: '#cbb89d',
            borderRadius: 8,
            marginBottom: 8
          }}></span> */}
          <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontWeight: 700,
            fontSize: 32,
            margin: 0,
            color: '#222'
          }}>
            Trabelci
          </h1>
        </div>
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">אימייל / שם משתמש</label>
            <div className="input-icon">
              <input
                type="text"
                id="email"
                name="email"
                placeholder="הכנס אימייל או שם משתמש"
                autoComplete="username"
                value={credentials.email}
                onChange={handleInputChange}
                disabled={isLoading}
              />
              <span className="icon">📧</span>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="password">סיסמה</label>
            <div className="input-icon">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                placeholder="הכנס סיסמה"
                autoComplete="current-password"
                value={credentials.password}
                onChange={handleInputChange}
                disabled={isLoading}
              />
              <span
                className="icon icon-clickable"
                onClick={() => setShowPassword(prev => !prev)}
                onKeyDown={(e) => e.key === 'Enter' && setShowPassword(prev => !prev)}
                role="button"
                tabIndex={0}
                title={showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'}
                aria-label={showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'}
              >
                {showPassword ? '🔓' : '🔒'}
              </span>
            </div>
          </div>
          {error && (
            <div style={{ 
              color: '#b71c1c', 
              marginBottom: 10, 
              textAlign: 'right', 
              fontSize: '0.98rem',
              padding: '10px',
              backgroundColor: '#ffebee',
              borderRadius: '4px',
              whiteSpace: 'pre-line'
            }}>
              {error}
            </div>
          )}
          <button type="submit" className="login-btn" disabled={isLoading}>
            {isLoading ? 'מתחבר...' : 'התחבר'}
          </button>
        </form>
      </div>
    </div>
  );
} 